import React from 'react';
import { connect } from 'react-redux';
import { Card, CardText } from 'react-toolbox/lib/card';

import widgets from '~/widgets.new';

import Styles from './style.scss';

class DrawDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderCell(cell, index) {
    const key = `${cell.type}_${index}`;
    const clear = cell.type === 'clear';

    if (clear) {
      return <div key={key} className={Styles[cell.type]} />;
    }

    const { dashboard } = this.props;
    const widgetName = dashboard.info.widget[index];
    const widgetSettings = dashboard.info.settings[index];
    const widget = widgets.widgets.find(w => w.name === widgetName);

    return (
      <div
        key={key}
        className={`${Styles.cell} ${Styles[cell.type]} ${
          widgetSettings.interactive ? Styles.interactive : ''
        }`}
        style={{ width: cell.width, height: cell.height }}
      >
        <Card className={Styles.cellCard}>
          <CardText className={Styles.cellCardText}>
            {widget.widget && (
              <widget.widget
                indata={widgetSettings}
                className={Styles.widget}
              />
            )}
            {!widget.widget && <div>Could not load widget</div>}
          </CardText>
        </Card>
      </div>
    );
  }

  render() {
    const { grid, dashboard } = this.props;
    const showName = dashboard.info && dashboard.info.showName;
    return (
      <div>
        {showName && (
          <div className={`${Styles.cell} ${Styles.nameCell}`}>
            <Card className={Styles.cellCard}>
              <CardText className={Styles.cellCardText}>
                <h1 className={Styles.title}>{dashboard.info.name}</h1>
              </CardText>
            </Card>
          </div>
        )}
        <div
          className={`${Styles.fullscreen} ${showName && Styles.nameVisible}`}
        >
          {grid.parts.map((cell, index) => this.renderCell(cell, index))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const dashboard = state
    .getIn(['dashboards', 'item', props.dashboardId], false)
    .toJS();
  const grid = widgets.grids.find(g => g.name === dashboard.info.gridType);
  return {
    dashboard,
    grid
  };
};

export default connect(mapStateToProps, null, null, { pure: false })(
  DrawDashboard
);



// WEBPACK FOOTER //
// ./app/pages/DashboardInit/drawDashboard.js